import React from 'react';
import { Helmet } from 'react-helmet';
import './about.css';

const About = () => {
  // JSON-LD structured data for About page
  const structuredData = {
    "@context": "https://schema.org",
    "@type": "AboutPage",
    "name": "About InspiraPix",
    "description": "Learn about InspiraPix's mission to democratize creativity through AI-powered image generation and manipulation tools.",
    "publisher": {
      "@type": "Organization",
      "name": "InspiraPix",
      "url": "https://inspirapix.com"
    }
  };

  return (
    <>
      <Helmet>
        <title>About InspiraPix | AI-Powered Creative Platform</title>
        <meta name="description" content="Learn about InspiraPix's mission to democratize creativity through AI-powered image generation. Discover our story, features, and commitment to innovation." />
        <meta name="keywords" content="InspiraPix, AI art generation, about us, creative platform, digital art" />
        <script type="application/ld+json">
          {JSON.stringify(structuredData)}
        </script>
      </Helmet>
      <div className="about-container">
        <div className="about-content">
          <section className="about-hero">
            <h1>About InspiraPix</h1>
            <p className="hero-subtitle">
              Empowering creativity through AI-powered image generation and manipulation
            </p>
          </section>

          <section className="about-mission">
            <h2>Our Mission</h2>
            <p>
              At InspiraPix, we believe in democratizing creativity by providing cutting-edge AI tools
              that help artists, designers, and creators bring their visions to life. Our platform
              combines state-of-the-art image generation technology with an intuitive user interface,
              making it accessible to everyone from beginners to professionals.
            </p>
          </section>

          <section className="about-features">
            <h2>What We Offer</h2>
            <div className="features-grid">
              <div className="feature-card">
                <h3>AI Image Generation</h3>
                <p>
                  Transform your ideas into stunning visuals using our advanced AI image generation
                  technology. Simply describe what you want to create, and watch as our AI brings
                  your vision to life.
                </p>
              </div>

              <div className="feature-card">
                <h3>Image Collections</h3>
                <p>
                  Organize and manage your generated images in personalized collections. Keep your
                  creative work organized and easily accessible whenever you need it.
                </p>
              </div>

              <div className="feature-card">
                <h3>Community Sharing</h3>
                <p>
                  Share your creations with our growing community of artists and creators. Get
                  inspired by others' work and showcase your own creative achievements.
                </p>
              </div>

              <div className="feature-card">
                <h3>Professional Tools</h3>
                <p>
                  Access a suite of professional tools for image editing, enhancement, and
                  customization. Take your creations to the next level with our advanced features.
                </p>
              </div>
            </div>
          </section>

          <section className="about-team">
            <h2>Our Team</h2>
            <p>
              We are a passionate team of developers, designers, and AI enthusiasts working
              together to push the boundaries of what's possible in creative technology. Our
              diverse backgrounds and shared vision drive us to continuously improve and innovate.
            </p>
          </section>

          <section className="about-values">
            <h2>Our Values</h2>
            <div className="values-grid">
              <div className="value-card">
                <h3>Innovation</h3>
                <p>
                  We constantly push the boundaries of what's possible with AI and creative
                  technology.
                </p>
              </div>

              <div className="value-card">
                <h3>Accessibility</h3>
                <p>
                  We believe creative tools should be accessible to everyone, regardless of their
                  technical background.
                </p>
              </div>

              <div className="value-card">
                <h3>Quality</h3>
                <p>
                  We maintain the highest standards in our technology and user experience.
                </p>
              </div>

              <div className="value-card">
                <h3>Community</h3>
                <p>
                  We foster a supportive environment where creators can learn, share, and grow
                  together.
                </p>
              </div>
            </div>
          </section>

          <section className="about-contact">
            <h2>Get in Touch</h2>
            <p>
              Have questions or suggestions? We'd love to hear from you! Reach out to our team
              at <a href="mailto:contact@inspirapix.com">contact@inspirapix.com</a> or visit our
              support page for more information.
            </p>
            <div className="contact-buttons">
              <a href="/contact" className="contact-btn">Contact Us</a>
              <a href="/support" className="support-btn">Visit Support</a>
            </div>
          </section>
        </div>
      </div>
    </>
  );
};

export default About; 